// extracted by mini-css-extract-plugin
export default {"test":"TimeTab_test__KGGTI"};